import gql from 'graphql-tag';

import type { ApprovalType, BrandTerm, PartOfSpeech } from 'src/data/brandTerm';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_TERM } from './schema';

const MUTATION = gql`
  mutation UpdateBrandTerm(
    $id: ID!
    $term: String
    $approvalType: BrandTermApprovalTypeEnum!
    $replaceWith: String
    $partOfSpeech: BrandTermPartOfSpeechEnum
    $caseSensitive: Boolean
    $capitalizeAtStart: Boolean
    $consistentHyphenation: Boolean
    $commonMistakes: [String!]
    $description: String
    $tags: [String!]
  ) {
    updateBrandTerm(
      id: $id
      term: $term
      approvalType: $approvalType
      replaceWith: $replaceWith
      partOfSpeech: $partOfSpeech
      caseSensitive: $caseSensitive
      capitalizeAtStart: $capitalizeAtStart
      consistentHyphenation: $consistentHyphenation
      commonMistakes: $commonMistakes
      description: $description
      tags: $tags
    ) {
      ...BrandTerm
    }
  }
  ${FRAGMENT_BRAND_TERM}
`;

interface Variables extends GqlCallVariables {
  id: ID;
  approvalType: ApprovalType;
  term?: string;
  replaceWith?: string;
  partOfSpeech?: PartOfSpeech;
  caseSensitive?: boolean;
  capitalizeAtStart?: boolean;
  consistentHyphenation?: boolean;
  commonMistakes?: string[];
  description?: string;
  tags?: string[];
}

export const updateBrandTerm = async (variables: Variables): Promise<BrandTerm | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BrandTerm>(result.data);
};
